import {BitrixVue} from 'ui.vue3';
import { mapState } from 'ui.vue3.pinia';
import { vplSiteStore } from 'vpl.tas';
import { ItemEditBtns } from 'vpl.tas';
import { num_word } from 'vpl.tas';


export const OsnashenieSections = {
    components: {
        ItemEditBtns
    },
    props: {
        structKey: [String, Number]
    },
    methods: {

    },
    updated(){

    },
    mounted(){


    },
    computed: {
        ...mapState(vplSiteStore, ['struct', 'SITE_TEMPLATE_PATH'])
    },
    template: `
<div v-if="this.struct[this.structKey].componentData.ITEMS" style="display: contents;">
    <section class="section section--first">
        <div class="container">
            <div class="services">
                <div class="services__text content" v-html="this.struct[this.structKey].componentData.TEXT">
                </div>
                <div class="services__img">
                    <picture>
                        <source type="image/avif" :srcset="this.SITE_TEMPLATE_PATH + '/img/content/instrument.avif'">
                        <source type="image/webp" :srcset="this.SITE_TEMPLATE_PATH + '/img/content/instrument.webp'">
                        <img :src="this.SITE_TEMPLATE_PATH + '/img/content/instrument.png'" alt="" title="" width="1134" height="756" fetchpriority="high">
                    </picture>
                </div>
            </div>
        </div>
    </section>
    <section class="section section--gray2">
        <div class="container">
            <div class="instrumentation__list instrumentation__list--compact" style="display: grid;">
                <div v-for="item in this.struct[this.structKey].componentData.ITEMS" class="header__bottom-nav-dropdown-block">
                    <a :href="item.LINK" class="header__bottom-nav-dropdown-block-title">
                        <div v-if="item.ICON !== false" class="header__bottom-nav-dropdown-block-title-icon">
                            <img :src="item.ICON" :alt="item.NAME" :title="item.NAME">
                            <img :src="(item.ICON_H !== false ? item.ICON_H : item.ICON)" class="hover" :alt="item.NAME" :title="item.NAME">
                        </div>
                        {{item.NAME}}
                    </a>
                    <div class="header__bottom-nav-dropdown-block-title-desc">
                        {{item.TEXT}}
                    </div>
                    <ul v-if="item.ITEMS && item.ITEMS.length" class="header__bottom-nav-dropdown-block-list">
                        <li v-for="subItem in item.ITEMS">
                            <a :href="subItem.LINK">{{subItem.NAME}}</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </section>
</div>
    `
}
 
;(function () {
    'use strict';

    var limit = 5;
    var rootSelector = '.instrumentation__list--compact';
    var listSelector =
        '.header__bottom-nav-dropdown-block-list';
    var buttonClass = 'tas-osnashenie-more';

    function getItems(list) {
        return Array.prototype.filter.call(
            list.children,
            function (item) {
                return !item.classList.contains(buttonClass);
            }
        );
    }

    function updateList(list) {
        var items = getItems(list);
        var extra = items.length - limit;
        var expanded =
            list.getAttribute('data-tas-expanded') === '1';
        var button = list.parentNode.querySelector(
            ':scope > .' + buttonClass
        );

        if (extra <= 0) {
            if (button) {
                button.parentNode.removeChild(button);
            }

            items.forEach(function (item) {
                item.classList.remove('tas-osnashenie-hidden');
            });

            return;
        }

        items.forEach(function (item, index) {
            item.classList.toggle(
                'tas-osnashenie-hidden',
                !expanded && index >= limit
            );
        });

        if (!button) {
            button = document.createElement('button');
            button.type = 'button';
            button.className = buttonClass;
            button.setAttribute('aria-expanded', 'false');

            list.insertAdjacentElement('afterend', button);

            button.addEventListener('click', function () {
                var isExpanded =
                    list.getAttribute('data-tas-expanded') === '1';

                list.setAttribute(
                    'data-tas-expanded',
                    isExpanded ? '0' : '1'
                );

                updateList(list);
            });
        }

        button.textContent = expanded
            ? 'Свернуть'
            : 'Ещё ' + extra + ' направлений';

        button.setAttribute(
            'aria-expanded',
            expanded ? 'true' : 'false'
        );

        button.classList.toggle(
            'is-expanded',
            expanded
        );
    }

    function init() {
        document
            .querySelectorAll(rootSelector)
            .forEach(function (root) {
                root
                    .querySelectorAll(listSelector)
                    .forEach(updateList);
            });
    }

    function start() {
        init();

        var timer = null;

        new MutationObserver(function () {
            window.clearTimeout(timer);
            timer = window.setTimeout(init, 50);
        }).observe(document.body, {
            childList: true,
            subtree: true
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener(
            'DOMContentLoaded',
            start
        );
    } else {
        start();
    }
})();